import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, black, white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  list: {
    backgroundColor: white,
    height: '100%',
  },
  noResultsContainer: {
    paddingTop: indent * 6,
    alignSelf: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 56,
    height: 56,
    fontSize: 56,
    alignSelf: 'center',
    marginBottom: indent * 1.8,
  },
  heading: {
    marginBottom: indent * 0.5,
  },
  text: {
    alignSelf: 'center',
  },
  headerContainer: {
    backgroundColor: alabaster,
    paddingHorizontal: indent * 0.85,
    paddingVertical: indent * 0.4,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: indent * 0.6,
  },
  headerText: {
    color: black,
    fontWeight: '600',
  },
  buttonContainer: {
    backgroundColor: white,
    alignItems: 'center',
    flexDirection: 'row',
    borderColor: alto,
    borderWidth: 1,
    borderRadius: 8,
    paddingVertical: indent * 0.4,
    paddingHorizontal: indent * 0.8,
  },
  emptyHeaderContainer: {
    backgroundColor: alabaster,
    paddingHorizontal: indent * 0.85,
    paddingVertical: indent * 0.9,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: indent * 0.6,
  },
});
